import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=04734364&scoped=true&"
import script from "./AvatarEditor.vue?vue&type=script&lang=js&"
export * from "./AvatarEditor.vue?vue&type=script&lang=js&"
import style0 from "./AvatarEditor.vue?vue&type=style&index=0&id=04734364&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04734364",
  null
  
)

export default component.exports